import axios from 'axios'
import { WIDGET_SERVICE_URL } from '../../utils/urls'
import { getUserToken } from '../../utils/browser'
import { WIDGET_LANG_KEY } from 'app/constants/globalVariables'

export const handleFetchWidgetInfo = async () => {
  const userId = getUserToken()
  const langValue = window[WIDGET_LANG_KEY] || window.parent?.[WIDGET_LANG_KEY]

  const userIdParam = userId ? `rid=${userId}&` : ''
  const langParam = langValue ? `lang=${langValue}&` : ''
  const hrefParam = `href=${window.parent.location}`

  const response = await axios({
    method: 'get',
    baseURL: WIDGET_SERVICE_URL,
    url: `/widget/${window.parent.RAYCHAT_TOKEN}?${userIdParam}${langParam}${encodeURI(hrefParam)}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}
